export default __webpack_public_path__ + "static/media/room.cf5e03a4.jpg";